module.exports = __webpack_public_path__ + "img/2_1-residenziale-appartamenti-0.94f90964.png";